module.exports = __webpack_public_path__ + "static/avatar-9194306f6e784c50873b4755ddfd4900.png";